import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NotificationItem } from '@src/app/core/models/notification-item';
import { format, parseJSON } from 'date-fns';
import { AppConfig, UserProfileService } from 'sigv-library';
import { NotificationInfoTransformer } from '../../core/services/notification-info-handler.service';

@Injectable()
export class WebsubmissionNitificationInfoTransformer implements NotificationInfoTransformer {

  systemCode = 'ExWebSubmission';

  constructor(
    private userProfileService: UserProfileService,
    private translateService: TranslateService) { }

  getTitle(value: NotificationItem): string {
    const useRole = this.userProfileService.currentUserValue?.extranetUserRole;
    let title = '';
    switch (value.extensions?.caseStatus) {
      case '1':
        title = 'CaseStatus.1';
        break;
      case '10':
        title = 'CaseStatus.10';
        break;
      case '30':
        title = 'News.CaseStatus.30-0';
        break;
      case '20':
        title = 'CaseStatus.20';
        break;
      case '40':
        title = 'News.CaseStatus.40';
        break;
      case '50':
        title = 'CaseStatus.50';
        break;
      case '60':
        title = 'CaseStatus.60';
        break;
      case '80':
        title = 'CaseStatus.80';
        break;
      case '120':
        title = `CaseStatus.120-${useRole}`;
        break;
      case '140':
      case '141':
      case '142':
        title = 'CaseStatus.140';
        break;
      case '90':
        title = `CaseStatus.90-${useRole}`;
        break;
      case '110':
        title = 'CaseStatus.110';
        break;
      case '170':
        title = 'CaseStatus.170';
        break;
      case '70':
        title = 'News.CaseStatus.70'
        break;
      case '130':
        title = 'CaseStatus.130';
        break;
      case '100':
        title = 'CaseStatus.100';
        break;
      case '160':
        title = 'CaseStatus.160';
        break;
      case '150':
        title = `CaseStatus.150-${useRole}`;
        break;
      case '151':
      case '152':
      case '153':
      case '154':
      case '161':
        title = 'CaseStatus.70';
        break;
      case '180':
        title = 'CaseStatus.180';
        break;
      case '190':
        title = 'CaseStatus.190';
        break;
      case '200':
        title = 'CaseStatus.200';
        break;
      case '210':
        title = 'CaseStatus.210';
        break;
      // 最新消息 - 下載合約
      case '-1':
        title = 'CaseStatus.-1';
        break;
      // 最新消息 - 下載登記文件
      case '-2':
        title = 'CaseStatus.-2';
        break;
      // 保險專區 - 報價完成
      case '-3':
        title = 'CaseStatus.-3';
        break;
      // 保險專區 - 投保完成
      case '-4':
        title = 'CaseStatus.-4';
        break;
      // 最新消息 - 預覽合約
      case '-5':
        title = 'CaseStatus.-5';
        break;
      default:
        break;
    }
    return title;
  }

  getContent(value: NotificationItem): string {
    const dateFormat = AppConfig.envConfig.format.date;
    let replaceDesc = '';
    switch (value.extensions?.caseStatus) {
      case '30':
        replaceDesc = this.translateService.instant('News.Description.30');
        break;
      case '20':
        replaceDesc = this.translateService.instant('News.Description.20');
        break;
      case '40':
        replaceDesc = this.translateService.instant('News.Description.40');
        break;
      case '50':
        replaceDesc = this.translateService.instant('News.Description.50');
        break;
      case '170':
        replaceDesc = this.translateService.instant('News.Description.170');
        break;
      case '70':
        value.extensions?.replace.forEach((item: any, index: any) => {
          if (index === 1) {
            value.extensions!.description =  value.extensions!.description
              .replace(
                '{2}',
                this.translateService.instant('News.Description.70.2')
              )
              .replace(
                '{3}',
                format(parseJSON(new Date(item)), dateFormat)
              );
          } else {
            value.extensions!.description =  value.extensions!.description
              .replace(
                '{0}',
                this.translateService.instant('News.Description.70.1')
              )
              .replace(
                '{1}',
                format(parseJSON(new Date(item)), dateFormat)
              );
          }
        });
        return  value.extensions?.description;
      case '190':
        replaceDesc = this.translateService.instant('News.Description.190');
        break;
      case '210':
        replaceDesc = this.translateService.instant('News.Description.210');
        break;
      // 下載合約
      case '-1':
        value.extensions.replace.forEach((item: any, index: any) => {
          if (index === 1) {
            value.extensions!.description = value
              .extensions!.description.replace(
                '{2}',
                this.translateService.instant('News.Description.-1.2')
              )
              .replace(
                '{3}',
                format(parseJSON(new Date(item)), dateFormat)
              );
          } else {
            value.extensions!.description = value
              .extensions!.description.replace(
                '{0}',
                this.translateService.instant('News.Description.-1.1')
              )
              .replace(
                '{1}',
                format(parseJSON(new Date(item)), dateFormat)
              );
          }
        });
        return value.extensions?.description;
      // 下載設定文件
      case '-2':
        replaceDesc = this.translateService.instant('News.Description.-2');
        break;
      // 保險專區 - 報價完成
      case '-3':
        replaceDesc = this.translateService.instant('News.Description.-3');
        break;
      // 保險專區 - 投保完成
      case '-4':
        replaceDesc = this.translateService.instant('News.Description.-4');
        break;
      // 預覽合約
      case '-5':
        replaceDesc = this.translateService.instant('News.Description.-5');
        break;
      default:
        return '';
    }

    return value.extensions?.description
      .replace('{0}', replaceDesc)
      .replace(
        '{1}',
        format(parseJSON(new Date(value.extensions.replace[0])), dateFormat)
      );
  }
}
